import React from 'react'

import OverviewView from 'features/catalog/components/OverviewView'
import { useOverview } from 'features/catalog/hooks/use-overview'
import { useCatalogService } from 'features/catalog/service'
import type { FocusListOption } from 'features/catalog/types'
import type { FilterUIState } from 'features/filters/store'
import { useFilterUIStore } from 'features/filters/store'
import { useProjectStore } from 'features/project/store'
import type { ProjectState } from 'types/project'
import type { Filters } from 'types/project'

export interface OverviewProps {
  item: FocusListOption
  filterValues: Filters
  tier1: string
  chartId: string
  subthemeName: string | null
  setSubthemeValue: (value: string | null) => void
  isLoading?: boolean
}

const Overview: React.FC<OverviewProps> = ({
  item,
  filterValues,
  tier1,
  chartId,
  subthemeName,
  setSubthemeValue,
  isLoading = false,
}) => {
  const catalogService = useCatalogService()
  const projectId = useProjectStore((state: ProjectState) => state.projectId)
  const defaultFilterList = useFilterUIStore(
    (state: FilterUIState) => state.defaultFilterList,
  )

  const overview = useOverview({
    catalogService,
    projectId,
    defaultFilterList,
    item,
    filterValues,
    tier1,
    chartId,
    enabled: !isLoading,
  })

  return (
    <OverviewView
      item={item}
      subthemeName={subthemeName}
      setSubthemeValue={setSubthemeValue}
      {...overview}
      statsLoading={isLoading || overview.comparisonLoading}
    />
  )
}

export default Overview
